<template>
  <div class="about">
    <div class="content">
      <div class="off-line">
        <h1><span class="line">|</span>离线统计数据</h1>
        <table class="table-content" cellspacing="0">
          <tr align="center" class="frist-list">
            <td>日期</td>
            <td>学号</td>
            <td>姓名</td>
            <td>楼号</td>
            <td>床号</td>
            <td>专业</td>
            <td>系学院</td>
            <td>学校</td>
            <td>累积离床</td>
          </tr>
          <tr align="center">
            <td>20210625</td>
            <td>20210687</td>
            <td>张三</td>
            <td>1号楼</td>
            <td>21034</td>
            <td>计算机应用</td>
            <td>计算机</td>
            <td>xxx大学</td>
            <td>5</td>
          </tr>
        </table>
      </div>
      <div class="sleep margin-top">
        <h1><span class="line">|</span>睡眠统计数据</h1>
        <table class="table-content" cellspacing="0">
          <tr align="center" class="frist-list">
            <td>日期</td>
            <td>学号</td>
            <td>姓名</td>
            <td>楼号</td>
            <td>床号</td>
            <td>呼吸</td>
            <td>心跳</td>
            <td>体动累计</td>
            <td>睡眠分值</td>
          </tr>
          <tr align="center">
            <td>20210625</td>
            <td>20210687</td>
            <td>张三</td>
            <td>1号楼</td>
            <td>21034</td>
            <td>{{ massege.breath }}</td>
            <td>{{ massege.heart }}</td>
            <td>{{ massege.motion }}</td>
            <td>5</td>
          </tr>
        </table>
      </div>
      <div class="warning margin-top">
        <h1><span class="line">|</span>健康预警统计数据</h1>
        <table class="table-content" cellspacing="0">
          <tr align="center" class="frist-list">
            <td>日期</td>
            <td>时间</td>
            <td>学号</td>
            <td>姓名</td>
            <td>楼号</td>
            <td>床号</td>
            <td>异常指标</td>
            <td>参考值</td>
            <td>实际值</td>
          </tr>
          <tr align="center">
            <td>20210625</td>
            <td>23：00</td>
            <td>2021897</td>
            <td>张三</td>
            <td>1号楼</td>
            <td>21034</td>
            <td>心跳</td>
            <td>70</td>
            <td>130</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "About",
  data() {
    return {
      massege: {
        breath: 0,
        heart: 0,
        motion: 0,
        timer: null
      },
    };
  },
  created() {
    this.fristData()
  },
  mounted() {
    this.$nextTick(() => {
      setInterval(this.CurentTime, 5000);
    });
  },
  methods: {
    async fristData() {
      let res = await axios.post(
        "http://47.110.252.158:8090/api/device/detailByBody1",
        { sn: "0100300246" }
      );
      let data = res.data.data;
      console.log(data.breath, data.heart, data.motion);
      this.massege.breath = data.breath;
      this.massege.heart = data.heart;
      this.massege.motion = data.motion;
    },
    CurentTime() {
      console.log("5秒一次喔");
      // 上线sn 0100300246   测试sn  0100300243
      axios
        .post("http://47.110.252.158:8090/api/device/detailByBody1", {
          sn: "0100300246",
        })
        .then((res) => {
          let data = res.data.data;
          console.log(data.breath, data.heart, data.motion);
          this.massege.breath = data.breath;
          this.massege.heart = data.heart;
          this.massege.motion = data.motion;
        });
    },
  },
};
</script>
<style scoped>
.about {
  position: relative;
  margin: 0 auto;
  width: 1920px;
  height: 1080px;
  background-size: cover;
  background-image: url("../assets/databg.jpg");
  background-repeat: no-repeat;
}
.content {
  position: absolute;
  width: 1660px;
  height: 780px;
  left: 126px;
  top: 200px;
  /* background: violet; */
}
.off-line,
.sleep,
.warning {
  color: #09a7b3;
}
.line {
  padding-right: 10px;
}
.table-content {
  border: 0.5px solid #fff;
  color: #fff;
  margin-top: 30px;
  font-size: 20px;
}
.table-content td {
  border: 1px solid #fff;
  color: #fff;
}
.frist-list {
  background-color: #09a7b3;
  font-weight: bold;
}
.table-content td {
  width: 300px;
  height: 80px;
}
.margin-top {
  margin-top: 30px;
}
</style>
